module.exports = __webpack_public_path__ + "static/media/me.0c3be0b6.jpg";